import { LexicalComposer } from "@lexical/react/LexicalComposer";

import { EditorContent } from "@/features/notes/components/Editor/components/EditorContent";
import { LEXICAL_COMPOSE_CONFIG } from "@/features/notes/config";
import { EditorData } from "../types";
import { EditorProps } from "./Editor";

interface SHaredNoteEditorProps extends Pick<EditorProps, "refetchedNote"> {
  data: EditorData;
}

export function SharedNoteEditor({ data, refetchedNote }: SHaredNoteEditorProps) {
  return (
    <LexicalComposer
      initialConfig={{
        ...LEXICAL_COMPOSE_CONFIG,
        namespace: "shared-note-editor",
        onError: () => {},
        editable: false,
      }}
    >
      <div className="min-h-0 flex-1 overflow-auto">
        <EditorContent
          initialContent={data?.html_content}
          isEditable={false}
          isLinkEditMode={false}
          refetchedNote={refetchedNote}
          onSetIsLinkEditMode={() => {}}
        />
      </div>
    </LexicalComposer>
  );
}
